import type { Property, PropertyType } from '@/features/home/types/property';

export const APP_NAME = 'DC Commercial';

export const PROPERTY_TYPES: ReadonlyArray<PropertyType> = [
  'Warehouse',
  'Office',
  'Retail',
  'Showroom',
  'Development',
  'Factory',
  'Land',
  'Medical/Consulting',
  'Other',
];

export const HERO = {
  title: 'Find Your Next Commercial Property',
  subtitle:
    'Search offices, retail, industrial, medical and development listings across the Darling Downs region.',
  image:
    'https://images.unsplash.com/photo-1486406146926-c627a92ad1ab?auto=format&fit=crop&w=2000&q=80',
} as const;

export const SAMPLE_LISTINGS: Property[] = [
  {
    id: '12014',
    slug: '6-209-james-street-toowoomba-city-q-4350',
    status: 'For Lease',
    type: 'Office',
    price: '$19,000 pa',
    address: '6/209 James Street',
    suburb: 'Toowoomba City',
    area: 152,
    bedrooms: 0,
    bathrooms: 1,
    image:
      'https://images.unsplash.com/photo-1486406146926-c627a92ad1ab?auto=format&fit=crop&w=900&q=80',
    gallery: [
      'https://images.unsplash.com/photo-1486406146926-c627a92ad1ab?auto=format&fit=crop&w=900&q=80',
      'https://images.unsplash.com/photo-1497366216548-37526070297c?auto=format&fit=crop&w=900&q=80',
      'https://images.unsplash.com/photo-1497366811353-6870744d04b2?auto=format&fit=crop&w=900&q=80',
      'https://images.unsplash.com/photo-1568992687947-868a62a9f521?auto=format&fit=crop&w=900&q=80',
      'https://images.unsplash.com/photo-1568992687947-868a62a9f521?auto=format&fit=crop&w=900&q=80',
    ],
    lat: -27.561,
    lng: 151.953,
    tags: [
      'Approx. 152m² first floor tenancy',
      'Expansive 108m² open-plan workspace',
      'Large windows providing excellent natural light',
      'Air-conditioned front room',
      'Private 30m² open balcony',
      'Separate WC + kitchenette + shower',
      'Exclusive access via private street-front stair entry',
      'Completely self-contained & private',
      'Character facade with strong street presence',
      'Prime city-centric location on the fringe of the CBD',
    ],
  },
  {
    id: '12015',
    slug: '6-taylor-street-toowoomba-city-q-4350',
    status: 'For Lease',
    type: 'Retail',
    price: '$80,000 pa',
    address: '6 Taylor Street',
    suburb: 'Toowoomba City',
    area: 320,
    bedrooms: 0,
    bathrooms: 2,
    image:
      'https://images.unsplash.com/photo-1497366216548-37526070297c?auto=format&fit=crop&w=900&q=80',
    gallery: [
      'https://images.unsplash.com/photo-1497366216548-37526070297c?auto=format&fit=crop&w=900&q=80',
      'https://images.unsplash.com/photo-1497366811353-6870744d04b2?auto=format&fit=crop&w=900&q=80',
      'https://images.unsplash.com/photo-1568992687947-868a62a9f521?auto=format&fit=crop&w=900&q=80',
    ],
    lat: -27.564,
    lng: 151.955,
  },
  {
    id: '12016',
    slug: '14-archibald-street-toowoomba-city-q-4350',
    status: 'For Lease',
    type: 'Office',
    price: '$35,000 pa',
    address: '14 Archibald Street',
    suburb: 'Toowoomba City',
    area: 180,
    bedrooms: 0,
    bathrooms: 1,
    image:
      'https://images.unsplash.com/photo-1497366811353-6870744d04b2?auto=format&fit=crop&w=900&q=80',
    gallery: [
      'https://images.unsplash.com/photo-1497366811353-6870744d04b2?auto=format&fit=crop&w=900&q=80',
      'https://images.unsplash.com/photo-1568992687947-868a62a9f521?auto=format&fit=crop&w=900&q=80',
      'https://images.unsplash.com/photo-1486406146926-c627a92ad1ab?auto=format&fit=crop&w=900&q=80',
      'https://images.unsplash.com/photo-1497366216548-37526070297c?auto=format&fit=crop&w=900&q=80',
    ],
    lat: -27.559,
    lng: 151.949,
  },
  {
    id: '12017',
    slug: '7-fitzgibbon-street-toowoomba-city-q-4350',
    status: 'For Sale',
    type: 'Warehouse',
    price: '$5,600,000',
    address: '7 Fitzgibbon Street',
    suburb: 'Toowoomba City',
    area: 1850,
    bedrooms: 0,
    bathrooms: 4,
    image:
      'https://images.unsplash.com/photo-1545324418-cc1a3fa10c00?auto=format&fit=crop&w=900&q=80',
    gallery: [
      'https://images.unsplash.com/photo-1545324418-cc1a3fa10c00?auto=format&fit=crop&w=900&q=80',
      'https://images.unsplash.com/photo-1486325212027-8081e485255e?auto=format&fit=crop&w=900&q=80',
      'https://images.unsplash.com/photo-1582407947304-fd86f028f716?auto=format&fit=crop&w=900&q=80',
      'https://images.unsplash.com/photo-1512917774080-9991f1c4c750?auto=format&fit=crop&w=900&q=80',
    ],
    lat: -27.566,
    lng: 151.952,
  },
  {
    id: '12018',
    slug: '18-saleyard-road-gatton-q-4350',
    status: 'For Lease',
    type: 'Factory',
    price: '$45,000 pa',
    address: '18 Saleyard Road',
    suburb: 'Gatton',
    area: 720,
    bedrooms: 0,
    bathrooms: 1,
    image:
      'https://images.unsplash.com/photo-1586528116311-ad8dd3c8310d?auto=format&fit=crop&w=900&q=80',
    gallery: [
      'https://images.unsplash.com/photo-1586528116311-ad8dd3c8310d?auto=format&fit=crop&w=900&q=80',
      'https://images.unsplash.com/photo-1565891741441-64926e441838?auto=format&fit=crop&w=900&q=80',
      'https://images.unsplash.com/photo-1601001815961-9a3ff3a8b22b?auto=format&fit=crop&w=900&q=80',
      'https://images.unsplash.com/photo-1553413077-190dd305871c?auto=format&fit=crop&w=900&q=80',
    ],
    lat: -27.555,
    lng: 152.279,
  },
  {
    id: '12019',
    slug: 'lot-12-brook-street-highfields-q-4350',
    status: 'For Sale',
    type: 'Development',
    price: '$1,250,000',
    address: 'Lot 12 Brook Street',
    suburb: 'Highfields',
    area: 2400,
    bedrooms: 0,
    bathrooms: 0,
    image:
      'https://images.unsplash.com/photo-1500382017468-9049fed747ef?auto=format&fit=crop&w=900&q=80',
    gallery: [
      'https://images.unsplash.com/photo-1500382017468-9049fed747ef?auto=format&fit=crop&w=900&q=80',
      'https://images.unsplash.com/photo-1500382017468-9049fed747ef?auto=format&fit=crop&w=900&q=81',
      'https://images.unsplash.com/photo-1500382017468-9049fed747ef?auto=format&fit=crop&w=900&q=82',
      'https://images.unsplash.com/photo-1500382017468-9049fed747ef?auto=format&fit=crop&w=900&q=83',
    ],
    lat: -27.463,
    lng: 151.953,
  },
  {
    id: '12020',
    slug: '22-24-hume-street-toowoomba-city-q-4350',
    status: 'For Lease',
    type: 'Medical/Consulting',
    price: '$95,000 pa',
    address: '22-24 Hume Street',
    suburb: 'Toowoomba City',
    area: 240,
    bedrooms: 0,
    bathrooms: 2,
    image:
      'https://images.unsplash.com/photo-1519494026892-80bbd2d6fd0d?auto=format&fit=crop&w=900&q=80',
    gallery: [
      'https://images.unsplash.com/photo-1519494026892-80bbd2d6fd0d?auto=format&fit=crop&w=900&q=80',
      'https://images.unsplash.com/photo-1538108149393-fbbd81895907?auto=format&fit=crop&w=900&q=80',
      'https://images.unsplash.com/photo-1551076805-e1869033e561?auto=format&fit=crop&w=900&q=80',
      'https://images.unsplash.com/photo-1504439468489-892804be7967?auto=format&fit=crop&w=900&q=80',
    ],
    lat: -27.562,
    lng: 151.951,
  },
  {
    id: '12021',
    slug: '88-fitzgibbon-street-harlaxton-q-4350',
    status: 'For Sale',
    type: 'Retail',
    price: '$1,950,000',
    address: '88 Fitzgibbon Street',
    suburb: 'Harlaxton',
    area: 480,
    bedrooms: 0,
    bathrooms: 2,
    image:
      'https://images.unsplash.com/photo-1441986300917-64674bd600d8?auto=format&fit=crop&w=900&q=80',
    gallery: [
      'https://images.unsplash.com/photo-1441986300917-64674bd600d8?auto=format&fit=crop&w=900&q=80',
      'https://images.unsplash.com/photo-1556742049-0cfed4f6a45d?auto=format&fit=crop&w=900&q=80',
      'https://images.unsplash.com/photo-1567401893414-76b7b1e5a7a5?auto=format&fit=crop&w=900&q=80',
      'https://images.unsplash.com/photo-1604719312566-8912e9227c6a?auto=format&fit=crop&w=900&q=80',
    ],
    lat: -27.541,
    lng: 151.961,
  },
];

export const CONTACT = {
  companyName: 'DC Commercial',
  legalName: 'Drew Camm Commercial Pty Ltd',
  abn: '25 625 279 405',
  address: '96 Mort Street, Toowoomba QLD 4350',
  phone: '0432 055 250',
  phoneHref: 'tel:0432055250',
  email: 'juliem@dccommercial.com.au',
  emailHref: 'mailto:juliem@dccommercial.com.au',
  website: 'https://dev-dc-commercials.track-progress.com/',
  websiteLabel: 'dccommercial.com.au',
} as const;

export function gmailComposeHref(email: string): string {
  return `https://mail.google.com/mail/?view=cm&fs=1&to=${encodeURIComponent(email)}`;
}

export const WHY_CHOOSE = {
  subtitle:
    'Focusing on providing the highest level of service to all of our clients, DC Commercial has extensive knowledge and experience within the commercial real estate industry.',
} as const;

export interface WhyChooseItem {
  id: string;
  title: string;
  body: string;
}

export const WHY_CHOOSE_ITEMS: ReadonlyArray<WhyChooseItem> = [
  {
    id: 'local-expertise',
    title: 'Local Expertise',
    body: "We know Toowoomba and the Darling Downs. It's our home.",
  },
  {
    id: 'marketing-knowledge',
    title: 'Marketing Knowledge',
    body: 'Realtime market insights to help you make confident decisions.',
  },
  {
    id: 'wide-network',
    title: 'Wide Network',
    body: 'Strong connections with qualified buyers and investors.',
  },
  {
    id: 'results-focused',
    title: 'Results Focused',
    body: 'Customer satisfaction is our main goal.',
  },
];

// Back-compat alias for existing footer/carousel imports.
export type PropertyCard = Property;
export const CURRENT_LISTINGS = SAMPLE_LISTINGS;
export const RECENT_SUCCESSES = SAMPLE_LISTINGS.slice(0, 4);

export const LIVE_FROM_FIELD = {
  title: 'Live from the field',
} as const;

export type SocialPlatform = 'instagram' | 'facebook' | 'linkedin';

export interface LiveFromFieldItem {
  id: string;
  image: string;
  platform: SocialPlatform;
  handle: string;
  headline: string;
  href: string;
  isVideo?: boolean;
}

export const LIVE_FROM_FIELD_ITEMS: ReadonlyArray<LiveFromFieldItem> = [
  {
    id: 'live-1',
    image:
      'https://images.unsplash.com/photo-1497366216548-37526070297c?auto=format&fit=crop&w=900&q=80',
    platform: 'instagram',
    handle: '@dccommercial',
    headline:
      'Just listed! Brand new office space in the heart of Toowoomba CBD — 120m² ready to move in.',
    href: 'https://www.instagram.com',
  },
  {
    id: 'live-2',
    image:
      'https://images.unsplash.com/photo-1497366811353-6870744d04b2?auto=format&fit=crop&w=900&q=80',
    platform: 'facebook',
    handle: 'DC Commercial',
    headline:
      'Another successful lease signed at 14 Archibald Street — congratulations to both parties!',
    href: 'https://www.facebook.com',
  },
  {
    id: 'live-3',
    image:
      'https://images.unsplash.com/photo-1486406146926-c627a92ad1ab?auto=format&fit=crop&w=900&q=80',
    platform: 'instagram',
    handle: '@dccommercial',
    headline:
      'On-site this morning at 7 Fitzgibbon Street. Investment opportunity not to be missed.',
    href: 'https://www.instagram.com',
  },
  {
    id: 'live-4',
    image:
      'https://images.unsplash.com/photo-1554469384-e58fac16e23a?auto=format&fit=crop&w=900&q=80',
    platform: 'facebook',
    handle: 'DC Commercial',
    headline:
      'Welcoming clients to our open inspection this Saturday — 22-24 Hume Street, medical suite.',
    href: 'https://www.facebook.com',
  },
];
